<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright-t"><a id="page_iv">Copyright © Leo Bruce 1937</a></p><a id="page_iv">
<p class="copyright">First American Edition 1982 Academy Chicago</p>
<p class="copyright">Published by Academy Chicago</p>
<p class="copyright0">425 North Michigan Ave.</p>
<p class="copyright0">Chicago, IL 60611</p>
<p class="copyright">All rights reserved</p>
<p class="copyright">Printed and bound in the U.S.A.</p>
<p class="copyright">First paperback edition 1982 Academy Chicago</p>
<p class="copyright">Library of Congress Cataloging in Publication Data</p>
<p class="copyright">Bruce, Leo, 1903-1980.</p>
<p class="copyright-ind">Case without a corpse.</p>
<p class="copyright-ind1">Reprint. Originally published: London: G. Bles, 1937.</p>
<p class="copyright-ind">I. Title</p>
<p class="copyright0">PR6005.R673C38     1982     823’.912     82-3916</p>
<p class="copyright0">ISBN 0-89733-052-8                                AACR2</p>
<p class="copyright0">ISBN 0-89733-050-1 (pbk.)</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003_Copyright.vue?165bb752